const countryLanguageCode = {
    en: false,
    "en-IN": false,
    "pt-BR": true,
    "es-MX": true,
};

export const _isCommaAsDecimalSeprator = (lang = "en-IN") => {
    return countryLanguageCode[lang];
};
